import { SETTINGS_PATH } from "@bitwarden/web-vault/app/models/constants/global.constants";
import { ScopeValue } from "@bitwarden/web-vault/app/models/data/role-access.data";

// todo remove this as this shouldn't have "/"
export enum GlossRouteEnum {
  dashboard = "/primary-dashboard",
  cabinet = "/cabinet",
  account = "/manage/account",
  symbol = "/symbol",
  categories = "/manage/categories",
  classifications = "/manage/classifications",
  institutions = "/manage/institutions",
  import = "/import-management",
  reference = "/reference-management",
  estimates = "/estimates",
  preferences = "/preferences",
  sync = "/sync",
}

export enum GlossRoutes {
  Cabinet = "cabinet",
  Account = "account",
  Symbol = "symbol",
  Categories = "categories",
  Classifications = "classifications",
  Institutions = "institutions",
  Import = "import-management",
  Reference = "reference-management",
  Estimates = "estimates",
  Preferences = "preferences",
  Subscription = "subscription",
  Settings = "settings",
  Views = "views",
  Earn = "earn",
  Budget = "budget",
  Credits = "credits",
  Guide = "guide",
  Plugins = "plugins",
  /** Grocery price comparison across Aldi/Woolworths/Coles */
  GlossGrocery = "gloss-grocery",
  RecurringDetector = "recurring-detector",
  /** Desktop beta: imported source transactions inspector */
  SourceExplorer = "source-explorer",
  Organizations = "organizations",
  Collections = "collections",
}

export interface NavItem {
  routerLink: string[] | string;
  key: string;
  icon: string;
  label: string;
  currentUrl?: string;
  selectedIcon?: string;
  roleScope?: ScopeValue;
}

export const NavItemsMobile: NavItem[] = [
  {
    key: GlossRoutes.Views,
    routerLink: ["/", GlossRoutes.Views],
    icon: "views",
    label: "home",
    roleScope: "VIEWS",
  },
  {
    key: GlossRoutes.Credits,
    routerLink: ["/", GlossRoutes.Credits],
    icon: "rewards",
    label: "rewards",
    roleScope: "GLOSS",
  },
  {
    key: GlossRoutes.Account,
    routerLink: ["/manage", GlossRoutes.Account],
    icon: "accounts",
    label: "accounts",
    roleScope: "GLOSS",
  },
  {
    key: GlossRoutes.Budget,
    routerLink: ["/", GlossRoutes.Budget],
    icon: "budget",
    label: "budgets",
    roleScope: "GLOSS",
  },
  {
    routerLink: ["/manage", GlossRoutes.Categories],
    key: GlossRoutes.Categories,
    icon: "categories",
    label: "categories",
    roleScope: "GLOSS",
  },
  {
    key: GlossRoutes.Cabinet,
    routerLink: ["/", GlossRoutes.Cabinet],
    icon: "cabinet",
    label: "cabinet",
    roleScope: "BETA_ACCESS",
  },
  {
    key: GlossRoutes.Earn,
    routerLink: ["/", GlossRoutes.Earn],
    icon: "coins-hand",
    label: "earn",
    roleScope: "BETA_ACCESS",
  },
  {
    key: GlossRoutes.Plugins,
    routerLink: ["/", GlossRoutes.Plugins],
    icon: "plugins",
    label: "plugins",
    roleScope: "GLOSS",
  },
  {
    routerLink: ["/manage", GlossRoutes.Collections],
    key: GlossRoutes.Organizations, // persisted in preferences.pinnedNavOrder — do not rename
    icon: "institutions",
    label: "teams",
    roleScope: "BETA_ACCESS",
  },
  {
    key: GlossRoutes.Symbol,
    routerLink: ["/", GlossRoutes.Symbol],
    icon: "symbol",
    label: "symbols",
    roleScope: "GLOSS",
  },
  {
    key: GlossRoutes.Settings,
    routerLink: [SETTINGS_PATH],
    icon: "settings",
    label: "settings",
    roleScope: "GLOSS",
  },
  {
    key: GlossRoutes.Guide,
    routerLink: ["/", GlossRoutes.Guide],
    icon: "guide",
    label: "helpGuideMobile",
    roleScope: "GLOSS",
  },
  // {
  //   key: "help",
  //   routerLink: "",
  //   icon: "help",
  //   selectedIcon: "help-selected",
  //   label: "help",
  //   roleScope: "GLOSS",
  // },
];

export const NavItems: NavItem[] = [
  {
    routerLink: ["/", GlossRoutes.Views],
    key: GlossRoutes.Views,
    icon: "views",
    label: "home",
    roleScope: "VIEWS",
  },
  {
    routerLink: ["/", GlossRoutes.Credits],
    key: GlossRoutes.Credits,
    icon: "rewards",
    label: "rewards",
    roleScope: "GLOSS",
  },
  {
    routerLink: ["/manage", GlossRoutes.Account],
    key: GlossRoutes.Account,
    icon: "accounts",
    label: "accounts",
    roleScope: "GLOSS",
  },
  {
    routerLink: ["/", GlossRoutes.Budget],
    key: GlossRoutes.Budget,
    icon: "budget",
    label: "budgets",
    roleScope: "GLOSS",
  },
  {
    routerLink: ["/", GlossRoutes.Symbol],
    key: GlossRoutes.Symbol,
    icon: "symbol",
    label: "symbols",
    roleScope: "GLOSS",
  },
  {
    routerLink: ["/", GlossRoutes.Cabinet],
    key: GlossRoutes.Cabinet,
    icon: "cabinet",
    label: "cabinet",
    roleScope: "BETA_ACCESS",
  },
  {
    routerLink: ["/manage", GlossRoutes.Categories],
    key: GlossRoutes.Categories,
    icon: "categories",
    label: "categories",
    roleScope: "GLOSS",
  },
  {
    routerLink: ["/manage", GlossRoutes.Classifications],
    key: GlossRoutes.Classifications,
    icon: "classifications",
    label: "classifications",
    roleScope: "BETA_ACCESS",
  },
  {
    routerLink: ["/manage", GlossRoutes.Institutions],
    key: GlossRoutes.Institutions,
    icon: "institutions",
    label: "institutions",
    roleScope: "BETA_ACCESS",
  },
  {
    routerLink: ["/", GlossRoutes.Import],
    key: GlossRoutes.Import,
    icon: "import-data",
    label: "importData",
    roleScope: "BETA_ACCESS",
  },
  {
    routerLink: ["/", GlossRoutes.Reference],
    key: GlossRoutes.Reference,
    icon: "reference",
    label: "referenceData",
    roleScope: "BETA_ACCESS",
  },
  {
    routerLink: ["/", GlossRoutes.Estimates],
    key: GlossRoutes.Estimates,
    icon: "estimate",
    label: "estimates",
    roleScope: "BETA_ACCESS",
  },
  {
    routerLink: ["/manage", GlossRoutes.SourceExplorer],
    key: GlossRoutes.SourceExplorer,
    icon: "source-explorer",
    label: "sourceExplorer",
    roleScope: "BETA_ACCESS",
  },
  {
    routerLink: ["/", GlossRoutes.Earn],
    key: GlossRoutes.Earn,
    icon: "coins-hand",
    label: "earn",
    roleScope: "BETA_ACCESS",
  },
  {
    routerLink: ["/", GlossRoutes.Plugins],
    key: GlossRoutes.Plugins,
    icon: "plugins",
    label: "plugins",
    roleScope: "GLOSS",
  },
  {
    routerLink: ["/manage", GlossRoutes.Collections],
    key: GlossRoutes.Organizations, // persisted in preferences.pinnedNavOrder — do not rename
    icon: "institutions",
    label: "teams",
    roleScope: "BETA_ACCESS",
  },
  {
    routerLink: [SETTINGS_PATH],
    currentUrl: SETTINGS_PATH,
    key: GlossRoutes.Settings,
    icon: "settings",
    label: "settings",
    roleScope: "GLOSS",
  },
  {
    routerLink: ["/", GlossRoutes.Guide],
    key: GlossRoutes.Guide,
    icon: "guide",
    label: "helpGuide",
    roleScope: "GLOSS",
  },
];

export enum MainSettingsRoute {
  Profile = "profile",
  Security = "security",
  AdvancedFeatures = "advanced-features",
  Preferences = "preferences",
  Access = "access",
  Plans = "bundles",
  Subscription = "subscription",
  Storage = "storage",
  Notifications = "notifications",
}

export enum SecuritySettingsRoute {
  ChangePassword = "change-password",
  LoginDevices = "login-devices",
  EmergencyAccess = "emergency-access",
  TwoStepLogin = "two-step-login",
}
